export default "__VITE_ASSET__Bp4b2HVo__"